import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetTablesMutation, useSaveDataSourceMutation } from "./sqlApiSlice";
import TableSource from "./TableSource";
import ColumTable from "./ColumTable";
import { FaTableCells } from "react-icons/fa6";
import { FaDatabase } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import SelectBox from "../../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";

export default function ConfigdataSource() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const connectionId = searchParams.get("connectionId");
  // console.log(connectionId);
  function modifiedArray(array) {
    const modifiedArray = array.map((db) => {
      return {
        label: db,
        value: db,
      };
    });
    return modifiedArray;
  }
  const modifiedDatabasesArray = modifiedArray(location["state"]["response"]);
  // console.log(modifiedDatabasesArray);

  const [selectedDatabase, setSelectedDatabase] = useState(null);
  console.log(selectedDatabase);

  const [selectedTable, setSelectedTable] = useState("");
  console.log(selectedTable);

  const [nickName, setNickName] = useState("");
  console.log(nickName);

  const [getTables, { data: tableData, isLoading, isSuccess, isError, error }] =
    useGetTablesMutation();
  const [
    saveDataSource,
    {
      data: saveDataSourceMessage,
      isLoading: isSaveDataSourceLoading,
      isError: isSaveDataSourceError,
      isSuccess: isSaveDataSourceSuccess,
      error: saveDataSourceError,
    },
  ] = useSaveDataSourceMutation();

  if (isLoading) {
    console.log("loading...");
  }
  if (isError) {
    console.log(error);
  }
  if (isSuccess) {
    console.log(tableData["message"]);
  }
  const modifiedTablesArray =
    tableData !== undefined && tableData["tables"].length > 0
      ? modifiedArray(tableData["tables"])
      : [];
  console.log(modifiedTablesArray);

  useEffect(() => {
    if (selectedDatabase) {
      const body = { connectionId, selectedDatabase };
      getTables(body);
    }
  }, [selectedDatabase, connectionId, getTables]);

  useEffect(() => {
    if (selectedTable) {
      setNickName(selectedTable);
    }
  }, [selectedTable]);

  const handleDatabaseChange = (event) => {
    const database = event.target.value;
    console.log(database);
    setSelectedDatabase(database);
  };
  const handleTableChange = (event) => {
    const table = event.target.value;
    console.log(table);
    setSelectedTable(table);
  };
  if (isSaveDataSourceLoading) {
    console.log("loading...");
  }
  if (isSaveDataSourceError) {
    console.log(saveDataSourceError["data"]["message"]);
  }
  if (isSaveDataSourceSuccess) {
    console.log(saveDataSourceMessage.success);
  }
  useEffect(() => {
    if (saveDataSourceMessage && saveDataSourceMessage?.success) {
      const timer = setTimeout(() => {
        navigate("/datasource");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveDataSourceMessage]);
  const handleSaveDataSource = () => {
    const body = { connectionId, nickName, modifiedColumns: [] };
    console.log(body);
    saveDataSource(body);
  };

  return (
    <main className="flex flex-col items-center justify-start h-screen overflow-hidden">
      <header
        className="flex flex-col items-center justify-between w-full border-b h-auto px-2 bg-gray-100 md:flex-col lg:flex-row
      "
      >
        <div className="flex items-center justify-start gap-2 font-medium w-full md:w-full lg:w-[18%] h-full truncate md:py-1">
          Database Type
          <span className="flex items-center font-light border border-l-[4px] border-blue-950 px-2 w-auto gap-2">
            <FaDatabase className="text-blue-950" /> My SQL
          </span>
        </div>

        <div className="flex flex-col w-full md:w-full lg:w-[82%] lg:flex-row xl:w-[90%] xl:flex-row items-center md:justify-start lg:justify-between gap-2 h-auto md:py-1">
          <div className="flex flex-col lg:flex-row items-center justify-start w-full md:gap-y-2 lg:gap-x-2">
            <section
              className={`flex w-full md:w-full lg:w-[50%] items-center justify-start gap-2`}
            >
              <span
                className={`flex w-auto font-medium truncate text-center`}
              >
                Database Name
              </span>
              <section className="w-full md:w-[65%] lg:w-[33rem] items-center justify-start flex">
                <SelectBox
                  value={selectedDatabase}
                  optionsArray={modifiedDatabasesArray}
                  onChange={handleDatabaseChange}
                />
              </section>
            </section>

            <section
              className={`flex w-full md:w-full lg:w-[50%] items-center justify-start gap-2`}
            >
              <span
                className={`flex w-full md:w-[15%] font-medium truncate text-center`}
              >
                Tables
              </span>
              {selectedDatabase === null ? (
                <span className="flex items-center font-light border border-l-[4px] border-blue-950 px-2 w-full md:w-[85%] gap-2">
                  <FaTableCells className="text-blue-950" /> To select a table
                  select a database
                </span>
              ) : null}
              {modifiedTablesArray.length > 0 ? (
                <section className="w-full md:w-[85%] items-center justify-start flex">
                  <SelectBox
                    value={selectedTable}
                    optionsArray={modifiedTablesArray}
                    onChange={handleTableChange}
                    isArrayBig={modifiedTablesArray.length > 6}
                  />
                </section>
              ) : null}
            </section>
          </div>
        </div>
      </header>

      <section className="flex flex-col lg:flex-row w-full items-start justify-start h-auto lg:h-[87%] px-2 gap-2 overflow-hidden overflow-y-auto lg:overscroll-none lg:overflow-y-hidden">
        {selectedTable ? (
          <TableSource
            connectionId={connectionId}
            selectedTable={selectedTable}
            setNickName={setNickName}
            nickName={nickName}
          />
        ) : null}
        <ColumTable connectionId={connectionId} selectedTable={selectedTable} />
      </section>
      <div className="flex items-center justify-end gap-2 w-full h-auto py-4 pr-2">
        {isSaveDataSourceError ? (
          <p className="text-red-500">
            {saveDataSourceError["data"]["message"]}
          </p>
        ) : null}
        {isSaveDataSourceSuccess ? (
          <p className="text-green-500">{saveDataSourceMessage.success}</p>
        ) : null}
        <button
          className="bg-blue-950 text-white font-bold py-1 px-2 rounded"
          onClick={handleSaveDataSource}
          disabled={isSaveDataSourceLoading}
        >
          Save Data
        </button>
      </div>
    </main>
  );
}
